function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _object_destructuring_empty(o) {
    if (o === null || o === void 0) throw new TypeError("Cannot destructure " + o);
    return o;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import React from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { hideModal } from '../../../redux/actions';
import StartTrialWizard from './StartTrialWizard/StartTrialWizard';
export var START_TRIAL_MODAL = 'START_TRIAL_MODAL';
var StartTrialModal = function(_param) {
    var rest = _extends({}, _object_destructuring_empty(_param));
    var dispatch = useDispatch();
    var handleHide = function() {
        return dispatch(hideModal(START_TRIAL_MODAL));
    };
    var _rest_onHide, _rest_isHighResClicked;
    return /*#__PURE__*/ React.createElement(Modal, _object_spread({
        className: "StartTrialModal",
        centered: true,
        show: true,
        onHide: handleHide
    }, rest), /*#__PURE__*/ React.createElement(StartTrialWizard, _object_spread(_object_spread_props(_object_spread({
        onCancel: (_rest_onHide = rest.onHide) !== null && _rest_onHide !== void 0 ? _rest_onHide : handleHide
    }, rest.onStartTrial && {
        onStartTrial: rest.onStartTrial
    }), {
        isHighResClicked: (_rest_isHighResClicked = rest.isHighResClicked) !== null && _rest_isHighResClicked !== void 0 ? _rest_isHighResClicked : false
    }), rest.callback && {
        callback: rest.callback
    })));
};
export default StartTrialModal;
